import { Stethoscope, Building2, HeartHandshake, CalendarCheck } from "lucide-react";

const ITEMS = [
  { icon: Stethoscope, title: "Experienced Medical Professionals", text: "Qualified doctors who listen first." },
  { icon: Building2, title: "Modern Healthcare Facilities", text: "Clean, well-equipped clinical spaces." },
  { icon: HeartHandshake, title: "Patient-Centered Care", text: "Your comfort guides every decision." },
  { icon: CalendarCheck, title: "Convenient Appointments", text: "Book on WhatsApp in under a minute." },
];

export const TrustStrip = () => (
  <section className="border-y border-slate-200 bg-slate-50" data-testid="trust-strip">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-4 py-10 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
      {ITEMS.map(({ icon: I, title, text }) => (
        <div key={title} className="flex items-start gap-4" data-testid={`trust-item-${title.toLowerCase().replace(/\s+/g, "-")}`}>
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-800 text-white">
            <I className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <h3 className="text-sm font-semibold text-navy-900">{title}</h3>
            <p className="mt-1 text-xs leading-relaxed text-slate-500">{text}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
